export default __webpack_public_path__ + "static/Merlin-908a752c24c961abfd9ce562ae390102.png";